import { getSouthAusDateTime } from '@/../vue/online-booking/utils/dates';

export default {
    data: () => ({
        southAusDateTime: getSouthAusDateTime()
    }),
    mounted() {
        // Utility so DateTime can connect to reactive state in computed properties
        window.setInterval(() => {
            this.southAusDateTime = getSouthAusDateTime();
        }, 1000);
    }
};
